export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=704d82997df7e9237c56a7ec99d93d250f215f2a0b&name=pushAdClickData!'